export default __webpack_public_path__ + "static/media/icons8-landscaping.f5cde46d.svg";